import { FinanceDailyReportStateTypes, FinanceDailyReportActionTypes } from "./FinanceDailyReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FinanceDailyReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchBeforeDate: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FinanceDailyReportReducer = (
  state: FinanceDailyReportStateTypes = INITIAL_STATE,
  action: any
): FinanceDailyReportStateTypes => {
  switch (action.type) {
    case FinanceDailyReportActionTypes.FETCH_ALL_FINANCE_DAILY_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FinanceDailyReportActionTypes.FETCH_ALL_FINANCE_DAILY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FinanceDailyReportActionTypes.FETCH_ALL_FINANCE_DAILY_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FinanceDailyReportActionTypes.FETCH_ALL_FINANCE_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };


      case FinanceDailyReportActionTypes.FETCH_FINANCE_DAILY_REPORT:
      return {
        ...state,
        fetchBeforeDate: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FinanceDailyReportActionTypes.FETCH_FINANCE_DAILY_REPORT_RESET:
      return {
        ...state,
        fetchBeforeDate: resetApiCallState([]),
      };
    case FinanceDailyReportActionTypes.FETCH_FINANCE_DAILY_REPORT_FAILURE:
      return {
        ...state,
        fetchBeforeDate: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FinanceDailyReportActionTypes.FETCH_FINANCE_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        fetchBeforeDate: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };


    case FinanceDailyReportActionTypes.FETCH_ONE_FINANCE_DAILY_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FinanceDailyReportActionTypes.FETCH_ONE_FINANCE_DAILY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FinanceDailyReportActionTypes.FETCH_ONE_FINANCE_DAILY_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FinanceDailyReportActionTypes.FETCH_ONE_FINANCE_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FinanceDailyReportReducer;
